import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */

export const selectComments = (state) => state.comments || Map()

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */

export const selectCommentsData = (state) => selectComments(state).get('data', Map())

/**
 * Select the visible state for the comments
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectIsCommentsVisible = (state) => {
  const comments = selectComments(state)

  return comments.get('visible') || false
}
